import React, { useState } from "react";
import { Loader, Button } from "@mantine/core";

const highlightColor = "#2C2E33";

const getRowStyle = ({ isEven, isUnbanned, isHovering }) => {
  if (isUnbanned) {
    return {
      backgroundColor: isHovering ? "#29ab8717" : "#29ab873d",
    };
  }
  if (isEven) {
    return { backgroundColor: isHovering ? highlightColor : "#151e29" };
  }
  return {};
};

const BanRow = ({
  banInfo,
  index,
  setCurrentBanDetails,
  setIsBanDetailVisible,
  steamIsLoading,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const { bannedId, staffMemberId, banStart, banLength, banReason } = banInfo;
  const isEven = index % 2 === 0;

  const alternatingStyle = getRowStyle({
    isEven,
    isUnbanned: banInfo.isUnbanned,
    isHovering,
  });

  return (
    <tr
      style={alternatingStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <td>{bannedId}</td>
      <td>{staffMemberId}</td>
      <td>{banStart}</td>
      <td>{banLength}</td>
      <td>{banReason}</td>
      <td>
        <Button
          disabled={isLoading}
          onClick={async () => {
            setIsLoading(true);
            setCurrentBanDetails(banInfo);
            setIsLoading(false);
            setIsBanDetailVisible(true);
          }}
          radius="md"
          size="sm"
          variant="light"
          color="gray"
        >
          View More
          {steamIsLoading && (
            <Loader color="violet" style={{ paddingLeft: "8px" }} size="sm" />
          )}
        </Button>
      </td>
    </tr>
  );
};

export default BanRow;
